var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: "100%",
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9998 2.49766C9.88585 2.49766 2.4975 9.88601 2.4975 19C2.4975 28.114 9.88585 35.5023 18.9998 35.5023C28.1138 35.5023 35.5022 28.114 35.5022 19C35.5022 9.88601 28.1138 2.49766 18.9998 2.49766ZM5.49792 19C5.49792 11.5431 11.5429 5.49808 18.9998 5.49808C26.4567 5.49808 32.5018 11.5431 32.5018 19C32.5018 26.4569 26.4567 32.5019 18.9998 32.5019C11.5429 32.5019 5.49792 26.4569 5.49792 19ZM16.8316 11.7509C16.3712 11.444 15.7793 11.4154 15.2915 11.6764C14.8037 11.9375 14.4992 12.4459 14.4992 12.9991V25.0009C14.4992 25.5541 14.8037 26.0625 15.2915 26.3235C15.7793 26.5846 16.3712 26.556 16.8316 26.2491L25.8329 20.2483C26.2502 19.97 26.5009 19.5016 26.5009 19C26.5009 18.4984 26.2502 18.03 25.8329 17.7517L16.8316 11.7509ZM22.2961 19L17.4996 22.1977V15.8023L22.2961 19Z",
    fill: "#FDEE2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideo);
export default __webpack_public_path__ + "static/media/play-video.00e335537847a4bd3d773e363897f1d5.svg";
export { ForwardRef as ReactComponent };